import type { SiteDomain } from '@strata-monorepo/shared-types/src/Domain'

export const getCurrentSite = ({ useNewSite = false }: { useNewSite?: boolean }): SiteDomain => {
  const hostname = window.location.hostname
  const pathname = window.location.pathname

  const pathToSiteMap: Record<string, SiteDomain> = {
    'save-on-energy': 'saveonenergy.com',
    'choose-energy': 'chooseenergy.com',
    'texas-electric-rates': useNewSite ? 'new.texaselectricrates.com' : 'texaselectricrates.com',
    'choose-texas-power': useNewSite ? 'new.choosetexaspower.org' : 'choosetexaspower.org',
  }

  // Development environments check
  if (hostname === 'localhost') {
    const pathSegments = pathname.split('/')
    const path = pathSegments.length > 1 ? pathSegments[1] : ''

    if (path && path in pathToSiteMap) {
      return pathToSiteMap[path] as SiteDomain
    }

    // Default to saveonenergy.com
    console.log('site config - no matching path found, defaulting to saveonenergy.com')
    return 'saveonenergy.com'
  }

  // Remove staging and www from hostname
  const domain = hostname
    .replace('next.development.', '')
    .replace('development.', '')
    .replace('staging.', '')
    .replace('www.', '')

  switch (domain) {
    case 'saveonenergy.com':
    case 'chooseenergy.com':
      return domain as SiteDomain
    case 'texaselectricrates.com':
    case 'choosetexaspower.org':
      if (useNewSite) {
        return `new.${domain}` as SiteDomain
      }
      return domain as SiteDomain
    default:
      return 'saveonenergy.com'
  }
}

export const getApiUrl = (): string => {
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname.includes('development') ||
    window.location.hostname.includes('staging')
  ) {
    return 'https://api.staging.saveonenergy.cloud'
  }
  return 'https://api.saveonenergy.cloud'
}
